"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GKNavbar = void 0;
var React = __importStar(require("react"));
var common_1 = require("../../../common");
var _1 = require(".");
var reactstrap_1 = require("reactstrap");
require("./GKNavbar.css");
/** @deprecated in favor of GKMainNav (use via GKLayoutShell) */
var GKNavbar = /** @class */ (function (_super) {
    __extends(GKNavbar, _super);
    function GKNavbar(props) {
        var _this = _super.call(this, props) || this;
        _this.updateChildren = function () {
            var left = [];
            var right = [];
            React.Children.forEach(_this.props.children, function (child) {
                if (child.type === _1.GKNavbarLeft) {
                    left.push(child);
                }
                else if (child.type === _1.GKNavbarRight) {
                    right.push(child);
                }
            });
            _this.setState({ leftChildren: left, rightChildren: right });
        };
        _this.defaultGranularLogo = function () { return (React.createElement("svg", { id: "granular-logo", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 28 28", fill: "#C03031" },
            React.createElement("title", null, "Granular"),
            React.createElement("path", { d: "M0,13 L0,0 L28,0 L28,13 L0,13 Z\n                M0,28 L0,15 L13,15 L13,28 L0,28 Z\n                M22,21 L22,15 L28,15 L28,21 L22,21 Z\n                M15,28 L15,23 L28,23 L28,28 L15,28 Z" }))); };
        _this.state = {
            leftChildren: [],
            rightChildren: [],
        };
        return _this;
    }
    GKNavbar.prototype.componentDidMount = function () {
        this.updateChildren();
    };
    GKNavbar.prototype.componentDidUpdate = function (prevProps) {
        if (this.props.children !== prevProps.children) {
            this.updateChildren();
        }
    };
    GKNavbar.prototype.render = function () {
        var _a = this.state, leftChildren = _a.leftChildren, rightChildren = _a.rightChildren;
        return (React.createElement(reactstrap_1.Navbar, __assign({ color: "light" }, (0, common_1.mapDefaultProps)(this.props, { _gkComponentName: "gk-navbar" })),
            React.createElement(reactstrap_1.NavbarBrand, { href: this.props.href || "/" }, this.defaultGranularLogo()),
            leftChildren.length ? (React.createElement("div", { className: "gk-navbar-left ml-3 mr-auto" }, leftChildren)) : null,
            rightChildren.length ? (React.createElement("div", { className: "gk-navbar-right ml-auto" }, rightChildren)) : null));
    };
    return GKNavbar;
}(common_1.GKPureComponent));
exports.GKNavbar = GKNavbar;
